module.exports = __webpack_public_path__ + "img/6.7059a45b.png";